<div class="modal-body m-0 m-lg-3">
    <div class="h-100 d-flex align-items-center text-center">
        <div class="w-100 d-block my-4">
            <div class="w-100 mb-4" *ngIf="providerUrl">
                <img src="{{providerUrl}}" alt="SignatureProvider" class="signatureProvider" ngbAutofocus>
            </div>

            <div class="w-100 login">
                <a href="{{signatureProviderUrl}}" target="_blank" rel="opener">
                    <button type="button" class="btn btn-sm btn-primary" translate=Button.Login></button>
                </a>
            </div>
        </div>
    </div>
</div>